import { AbstractControl, Validator } from '@angular/forms';
import { Input } from '@angular/core';

import { Directive } from '@angular/core';
import { NG_VALIDATORS } from '@angular/forms';

import { BadwordsService } from 'projects/tools/src/lib/shared-module/leaderboard/badwords.service';

@Directive({
  selector: '[libLeaderboardNicknameValidator]',
  providers: [{ provide: NG_VALIDATORS, useExisting: LeaderboardNicknameValidatorDirective, multi: true }],
  standalone: true,
})
export class LeaderboardNicknameValidatorDirective implements Validator {
  constructor(private badwords: BadwordsService) {}

  @Input('libLeaderboardNicknameValidator') arg: string;

  validate(control: AbstractControl): { [key: string]: any } | null {
    const value: string = control.value;

    const [_minLength, _maxLength, ..._] = this.arg.split(',');

    const minLength = parseInt(_minLength, 10);
    const maxLength = parseInt(_maxLength, 10);

    if (value && this.badwords.emojiCheck(value)) {
      return { profaneEmoji: true };
    }

    if (value && this.badwords.simpleCheck(value)) {
      return { profanity: true };
    }

    if (!value || value.length < 1) {
      return { empty: true };
    }

    if (value && value.length < minLength) {
      return { minLength };
    }

    if (value && value.length > maxLength) {
      return { maxLength };
    }

    if (value && value.match(/[`~!@#\$%\^&\*\(\)\-=_+\\\[\]{}/\?,\.\<\>]/)) {
      return { specialChars: true };
    }
    return null; // Return null if validation passes
  }
}
